class RuleSettingsModel {
    constructor (data) {
        this.ruleSettings = data?.gameData?.ruleSettings;
        this.isDataLoaded = true;
        if (data?.length > 0) {
            this.hasData = true
        }
    }
}

export default RuleSettingsModel;
